import React from 'react'
import { RI_CLIC_ITI_MORE_RESULTS, TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import { PUB_TAG } from '../analytics/PublisherTags.tags'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'
import TagActionButton from '../genericComponents/TagActionButton'
import TagActionLink from '../genericComponents/TagActionLink'
import arrowRight from '../genericComponents/assets/arrow-right.svg'
import SVGIcon from '../svg/SVGIcon'
import s from './ProviderFooter.less'

const ProviderFooter = ({ route, hideInfo }) => {
  const footerKey = `footer-${route.provider}`

  if (!route?.moreTripsLink && !route?.info) {
    return <></>
  }

  return (
    <>
      {route.moreTripsLink && (
        <li className={s.providerFooter} key={footerKey}>
          <TagActionButton
            type={RI_CLIC_ITI_MORE_RESULTS}
            tagInfo={{ [CLICKED_BUTTON]: route.moreTripsLabel }}
            key={route.routeId}
            isSpan
          >
            <TagActionLink
              className={s.moreTripLink}
              href={route.moreTripsLink}
              nofollow={true}
              targetBlank={true}
              shouldTagImpression={true}
              tagInfo={{ tag: PUB_TAG.PUB_MULTIPATH_VOIRPLUSDETRAJETS, provider: route.provider }}
              type={TAG_MULTIPATH_CTA}
              dataset={{ [CLICKED_BUTTON]: route.moreTripsLabel }}
            >
              <span className={s.moreTripLink_text}>{route.moreTripsLabel}</span>
              <SVGIcon url={arrowRight} className={s.moreTripLink_icon} width="24" height="24" />
            </TagActionLink>
          </TagActionButton>
        </li>
      )}
      {route.info && !hideInfo && (
        <li className={s.providerFooter}>
          <span>{route.info}</span>
        </li>
      )}
    </>
  )
}

export default ProviderFooter
